import { API_URL, select } from "../../lib";
import { baseRequest } from "../../lib/request";
import {
  DraftUpsertOutcome,
  QuestionnaireDraftUpsertRequest,
} from "../../lib/questionnaire_draft/coordinator";
import { QuestionnaireDraftKey, QuestionnaireDraftSnapshot } from "../../model/questionnaire_draft";
import {
  QUESTIONNAIRE_DRAFT_REQUEST_TIMEOUT_MS,
  questionnaireDraftRequestData,
  runQuestionnaireDraftRequest,
} from "./questionnaire_draft_request";

const UPSERT_PATH = "/v1/web/questionnaire-draft-upsert";

// Saves the recovery copy the coordinator handed over
export function* sendQuestionnaireDraftUpsert({
  scope,
  key,
  draft,
  signal,
}: QuestionnaireDraftUpsertRequest): Generator<any, DraftUpsertOutcome, any> {
  const result = yield* runQuestionnaireDraftRequest({
    scope,
    path: UPSERT_PATH,
    data: questionnaireDraftRequestData(key, draft),
    signal,
  });
  if (result.kind !== "ok") return result;
  const updatedAt = result.payload?.updatedAt;
  // a reply without the server's time is not the contract's success, so the copy is tried again
  return typeof updatedAt === "string" ? { kind: "saved", updatedAt } : { kind: "retry" };
}

// The last attempt at sign-out: the token the store holds right now, no wait for a refresh, and no
// answer anyone waits on. The session scope has already ended, so this goes around the usual checks.
export function* sendFinalQuestionnaireDraftUpsert({
  key,
  draft,
}: {
  key: QuestionnaireDraftKey;
  draft: QuestionnaireDraftSnapshot;
}) {
  const accessToken: string | null = yield select((state: any) => state?.auth?.accessToken ?? null);
  if (!accessToken) return;
  void baseRequest({
    method: "post",
    url: `${API_URL}${UPSERT_PATH}`,
    accessToken,
    data: questionnaireDraftRequestData(key, draft),
    timeout: QUESTIONNAIRE_DRAFT_REQUEST_TIMEOUT_MS,
  });
}
